import type { ReactNode } from 'react';
import { Steps } from '@/components/ui';
import { setupGroups } from '@/utils/site-orders';
import type { SiteSetupView } from '@/types/api';

/**
 * A new site's creation as a checklist (ADR-0047): the job's steps grouped
 * into what a person recognises — the domain and server, WordPress, the
 * template's structure, DNS, the final check.
 */
export function SetupProgress({ setup }: { readonly setup: SiteSetupView | undefined }): ReactNode {
  return <Steps items={setupGroups(setup)} label="Ход создания" />;
}
